import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Typography } from '@dev/ee-components';
import { getFormCreatorStore } from '@/store/formCreator/actions';
import { Step5ContentWrapper } from './styles';

export const Step5Content = (): JSX.Element => {
    const { t } = useTranslation();
    const { popupDelay: seconds } = useSelector(getFormCreatorStore);

    return (
        <Step5ContentWrapper>
            <Typography variant="h3">{t('trigger')}:</Typography>
            <Typography variant="body1">{seconds === 1 ? t('trigger_popup_delay_one_description') : t('trigger_popup_delay_description', { seconds })}</Typography>
        </Step5ContentWrapper>
    );
};
